import { render, staticRenderFns } from "./PlatformSettings.vue?vue&type=template&id=4ab2df3f&scoped=true&"
import script from "./PlatformSettings.vue?vue&type=script&lang=js&"
export * from "./PlatformSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2df3f",
  null
  
)

export default component.exports